import { GetterTree } from 'vuex'
import { State } from './state'

export default <GetterTree<State, unknown>>{}
